import { eventanillaTypes } from "../constants/action-types"

const initialState = {
  subscribers: null,
  clientNames: null,
  error: null,
  searchValueCUIT: null,
  searchClientName: null,
  searchStatus: null,
  detailsSubscription: null,
  loading: false,
  addClient: {
    loading: false,
    success: false,
    data: null,
  },
  updateClient: {
    loading: false,
    success: false,
    data: null,
  },
  suscribersDelegation: {
    loading: false,
    success: false,
    data: null,
    pagination: {
      hasNextPage: false,
      hasPrevPage: false,
      itemCount: 0,
      next: null,
      page: 1,
      pageCount: 1,
      perPage: 5,
      prev: null,
    },
  },
  searchValueCUITSubscription: null,
  searchClientNameSubscription: null,
  searchuserNameSubscription: null,
  searchEvStatus: null,
  clientNamesSubscription: null,
  userNamesSubscription: null,
  dateFilter: null,
  evStatus: [
    "Cliente Adherido a e-ventanilla",
    "Cliente con observaciones",
    "Cliente no adherido a e-ventanilla",
    "CUIT No cargado como cliente",
  ],
}

export const eventanillaReducer = (state = initialState, action) => {
  switch (action.type) {
    case eventanillaTypes.EVENTANILLA_SUBSCRIBER_STATUS_REQUEST:
      return {
        ...state,
        subscribers: null,
        clientNames: null,
        error: null,
      }
    case eventanillaTypes.EVENTANILLA_SUBSCRIBER_STATUS_SUCCESS:
      return {
        ...state,
        subscribers: action.payload.data,
        clientNames: action.payload.customerSuborganizationNames,
        error: null,
      }

    case eventanillaTypes.EVENTANILLA_SUBSCRIBER_STATUS_CHANGE_ORDER:
      return {
        ...state,
        subscribers: action.payload.data,
      }
    case eventanillaTypes.EVENTANILLA_SUBSCRIBER_STATUS_FAILURE:
      return {
        ...state,
        subscribers: null,
        clientNames: null,
        error: action.payload,
      }
    case eventanillaTypes.EVENTANILLA_SUBSCRIBER_DETAILS_REQUEST:
      return {
        ...state,
        detailsSubscription: null,
      }
    case eventanillaTypes.EVENTANILLA_SUBSCRIBER_DETAILS_SUCCESS:
      return {
        ...state,
        detailsSubscription: action.payload,
      }
    case eventanillaTypes.EVENTANILLA_SUBSCRIBER_DETAILS_FAILURE:
      return {
        ...state,
        detailsSubscription: null,
        error: action.payload,
      }
    case eventanillaTypes.EVENTANILLA_SUBSCRIBER_DETAILS_CHANGE_ORDER:
      return {
        ...state,
        detailsSubscription: action.payload,
      }
    case eventanillaTypes.EVENTANILLA_UPDATE_SUBSCRIBER_STATUS_SUCCESS: {
      const index = state.subscribers.findIndex(
        (elemento) =>
          elemento.communicationSubscriptionVEId ===
          action.payload.communicationSubscriptionVEId,
      )
      const newstate = state
      if (index !== -1) newstate.subscribers[index] = action.payload
      return {
        ...state,
        subscribers: newstate.subscribers,
        error: null,
      }
    }
    case eventanillaTypes.EVENTANILLA_UPDATE_SUBSCRIBER_STATUS_SUCCESS_ARCA:
      return {
        updateClient: {
          ...state.updateClient,
          loading: false,
          success: true,
          data: action.payload,
        },
      }
    case eventanillaTypes.EVENTANILLA_UPDATE_SUBSCRIBER_STATUS_ERROR:
      return {
        ...state,
        error: action.payload,
      }
    case eventanillaTypes.EVENTANILLA_ADD_SEARCH_VALUE_CUIT:
      return {
        ...state,
        searchValueCUIT: action.payload,
      }
    case eventanillaTypes.EVENTANILLA_DELETE_SEARCH_VALUE_CUIT:
      return {
        ...state,
        searchValueCUIT: null,
      }
    case eventanillaTypes.EVENTANILLA_CHANGE_SEARCH_CLIENT_NAMES:
      return {
        ...state,
        searchClientName: action.payload,
      }
    case eventanillaTypes.EVENTANILLA_CHANGE_SEARCH_STATUS:
      return {
        ...state,
        searchStatus: action.payload,
      }
    case eventanillaTypes.EVENTANILLA_DELETE_SEARCH_VALUE_CLIENT_NAME:
      return {
        ...state,
        searchClientName: action.payload,
      }
    case eventanillaTypes.EVENTANILLA_DELETE_SEARCH_VALUE_STATUS:
      return {
        ...state,
        searchStatus: null,
      }
    case eventanillaTypes.EVENTANILLA_LOADING_ON:
      return {
        ...state,
        loading: true,
      }
    case eventanillaTypes.EVENTANILLA_LOADING_OFF:
      return {
        ...state,
        loading: false,
      }
    case eventanillaTypes.EVENTANILLA_CREATE_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        suscribersDelegation: {
          ...state.suscribersDelegation,
          loading: false,
          success: true,
          data: action.payload,
        },
      }
    case eventanillaTypes.EVENTANILLA_UPDATE_SUBSCRIPTION_SUCCESS:
      return {
        updateClient: {
          ...state.updateClient,
          loading: false,
          success: true,
          data: action.payload,
        },
      }
    case eventanillaTypes.EVENTANILLA_GET_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        suscribersDelegation: {
          ...state.suscribersDelegation,
          loading: false,
          success: true,
          data: action.payload,
          pagination: action.payload.pagination,
        },
      }
    case eventanillaTypes.EVENTANILLA_ADD_SEARCH_VALUE_CUIT_SUBSCRIPTION:
      return {
        ...state,
        searchValueCUITSubscription: action.payload,
      }
    case eventanillaTypes.EVENTANILLA_DELETE_SEARCH_VALUE_CUIT_SUBCRIPTION:
      return {
        ...state,
        searchValueCUITSubscription: null,
      }
    case eventanillaTypes.EVENTANILLA_CHANGE_SEARCH_CLIENT_NAMES_SUBCRIPTION:
      return {
        ...state,
        searchClientNameSubscription: action.payload,
      }
    case eventanillaTypes.EVENTANILLA_DELETE_SEARCH_VALUE_CLIENT_NAME_SUBCRIPTION:
      return {
        ...state,
        searchClientNameSubscription: action.payload,
      }
    case eventanillaTypes.EVENTANILLA_DELEGATION_DATE_TIME_CHANGE_ORDER:
      return {
        ...state,
        suscribersDelegation: {
          ...state.suscribersDelegation,
          data: action.payload.data,
        },
      }
    case eventanillaTypes.EVENTANILLA_SET_CLIENT_NAMES_SUBSCRIPTION:
      return {
        ...state,
        clientNamesSubscription: action.payload,
      }
    case eventanillaTypes.EVENTANILLA_CHANGE_SEARCH_USER_NAMES_SUBCRIPTION:
      return {
        ...state,
        searchuserNameSubscription: action.payload,
      }
    case eventanillaTypes.EVENTANILLA_DELETE_SEARCH_VALUE_USER_NAME_SUBCRIPTION:
      return {
        ...state,
        searchuserNameSubscription: action.payload,
      }
    case eventanillaTypes.EVENTANILLA_SET_USER_NAMES_SUBSCRIPTION:
      return {
        ...state,
        userNamesSubscription: action.payload,
      }
    case eventanillaTypes.EVENTANILLA_SET_DATE_FILTER:
      return {
        ...state,
        dateFilter: action.payload,
      }
    case eventanillaTypes.EVENTANILLA_CLEAR_DATE_FILTER:
      return {
        ...state,
        dateFilter: null,
      }
    case eventanillaTypes.EVENTANILLA_SET_EV_STATUS:
      return {
        ...state,
        evStatus: action.payload,
      }
    case eventanillaTypes.EVENTANILLA_SET_SEARCH_EV_STATUS:
      return {
        ...state,
        searchEvStatus: action.payload,
      }
    case eventanillaTypes.EVENTANILLA_CLEAR_SEARCH_EV_STATUS:
      return {
        ...state,
        searchEvStatus: null,
      }
    default:
      return state
  }
}

export default eventanillaReducer
